import type { CharacterId, FlavorId } from '../sim/types';

export interface FlavorDefinition {
  id: FlavorId;
  name: string;
  recipe: string;
  specialName: string;
  ability: CharacterId;
  primary: number;
  secondary: number;
  muzzle: number;
  trail: number;
  icon: string;
}

export const FLAVORS: readonly FlavorDefinition[] = [
  {
    id: 'vanilla',
    name: 'Vanilla',
    recipe: 'Cream coat · blueberry scarf · wafer ear',
    specialName: 'Snow Blink',
    ability: 'mox',
    primary: 0xfff4d6,
    secondary: 0x6aa9ff,
    muzzle: 0xffffff,
    trail: 0xbfe9ff,
    icon: '✦',
  },
  {
    id: 'strawberry',
    name: 'Strawberry',
    recipe: 'Berry coat · seed freckles · mint leaf',
    specialName: 'Berry Echo',
    ability: 'vela',
    primary: 0xff7096,
    secondary: 0x68e0b2,
    muzzle: 0xffd7df,
    trail: 0xffa7bd,
    icon: '♥',
  },
  {
    id: 'greenApple',
    name: 'Green Apple',
    recipe: 'Tart coat · caramel scarf · leaf tuft',
    specialName: 'Crisp Blink',
    ability: 'mox',
    primary: 0xaeea55,
    secondary: 0xc47a43,
    muzzle: 0xeaffbd,
    trail: 0xd5ff7d,
    icon: '●',
  },
  {
    id: 'chocolate',
    name: 'Chocolate',
    recipe: 'Cocoa coat · vanilla muzzle · sprinkles',
    specialName: 'Cocoa Echo',
    ability: 'vela',
    primary: 0x7b4b3a,
    secondary: 0xffc75c,
    muzzle: 0xffe5bd,
    trail: 0xc68a69,
    icon: '◆',
  },
] as const;

export function getFlavor(id: FlavorId): FlavorDefinition {
  return FLAVORS.find((flavor) => flavor.id === id) ?? FLAVORS[0]!;
}

export function flavorFromLegacyPalette(palette: number): FlavorId {
  return FLAVORS[Math.max(0, Math.min(FLAVORS.length - 1, palette))]?.id ?? 'vanilla';
}
